import { render, staticRenderFns } from "./BORComplaints.vue?vue&type=template&id=071b9ac4&"
import script from "./BORComplaints.vue?vue&type=script&lang=js&"
export * from "./BORComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports